import './chunk-6985c8ce.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { T as Tooltip } from './chunk-9ec85033.js';
export { T as BTooltip } from './chunk-9ec85033.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Tooltip);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/tooltip.js
// module id = 83
// module chunks = 10